export default __webpack_public_path__ + "static/media/btn_step_2_default.2fe42703.svg";